import type { components } from '@/../types/api'

type VideoItemOut = components['schemas']['VideoItemOut']
type UploadOut = components['schemas']['VideoItemUploadOut']

/** The fields of a list item that decide the card's date. ``VideoItem`` fits it. */
export interface CardDateSource {
  ui_status: VideoItemOut['ui_status']
  created_at?: string | null
  youtube_upload_date?: string | null
  upload?: Pick<UploadOut, 'uploaded_at'> | null
  youtube_stats?: components['schemas']['VideoItemYoutubeStatsOut'] | null
}

export interface CardDateInfo {
  kind: 'published' | 'created'
  iso: string
}

/**
 * The date shown on the card's hover: the publication date of a published
 * video, otherwise the creation date. ``published_at`` comes from the stats
 * sync (the real slot); ``uploaded_at`` covers a backend without the field.
 */
export function cardDateInfo(v: CardDateSource): CardDateInfo | null {
  if (v.ui_status === 'publicado') {
    const published = v.youtube_stats?.published_at ?? v.upload?.uploaded_at ?? v.youtube_upload_date
    if (published) return { kind: 'published', iso: published }
  }
  return v.created_at ? { kind: 'created', iso: v.created_at } : null
}
